import React, { useEffect, useState } from 'react';
import logo from '../../assets/images/cloudplexo-logo .svg';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import './Topbar.css';

const DesktopNav = () => {
    return (
        <div className="main-header-nav">
            <a href="/">
                <img
                    src={logo}
                    alt="Wendu - Cloud Security and Cost"
                />
            </a>
            <div className="header-links">
                <ul>
                    <li className="dropdown-container">
                        <a
                            className="nav-link"
                            href="#products"
                        >
                            <span>Solutions & Offerings</span>{' '}
                            <IoIosArrowDown />
                        </a>
                        <div className="drop-down dropdown-offerings">
                            <h4>Our Solutions & Offerings</h4>

                            <div className="drop-down-content">
                                <a href="https://wendu.io/">Wendu</a>
                                <a href="/data-analytics">AI Scan</a>
                                <a href="/aws-managed-cloud">
                                    AWS Managed Service
                                </a>
                                <a href="/backup-and-restore">
                                    Backup and Restore
                                </a>
                                <a href="/cloud-migration">Cloud Migration</a>
                                <a href="/aws-maturity-service">
                                    AWS Maturity Service
                                </a>
                                <a href="/security-compliance">
                                    Security Compliance
                                </a>
                                <a href="/microsoft-on-aws">Microsoft on AWS</a>
                                <a href="/cloud-resource-managament">
                                    Cloud Resource Management
                                </a>
                            </div>
                        </div>
                    </li>
                    <li className="dropdown-container">
                        <a
                            className="nav-link"
                            href="#professionalservices"
                        >
                            <span>Professional Services</span>{' '}
                            <IoIosArrowDown />
                        </a>
                        <div className="drop-down dropdown-professional">
                            <h4>Professional Services</h4>

                            <div className="drop-down-content">
                                <a href="/technologies">
                                    Omni-channel Contact Center
                                </a>
                                <a href="/devops-as-a-service">
                                    DevOps as a service
                                </a>
                                <a href="/training">Cloud Training</a>
                            </div>
                        </div>
                    </li>

                    <li className="dropdown-container">
                        <a
                            className="nav-link"
                            href="/aws-partnership"
                        >
                            AWS Partnership
                        </a>
                    </li>

                    <li className="dropdown-container">
                        <a
                            className="nav-link"
                            href="/case-studies"
                        >
                            Case Studies
                        </a>
                    </li>

                    <li className="dropdown-container">
                        <a
                            className="nav-link"
                            href="#resources"
                        >
                            <span>Resources</span> <IoIosArrowDown />
                        </a>
                        <div className="drop-down dropdown-resources">
                            <h4>Resources</h4>

                            <div className="drop-down-content">
                                <a href="/blog">Blogs</a>
                                <a href="/knowledge">Documentation CCMP</a>
                                <a href="/events">Events</a>
                                <a href="/press-release">Press Releases</a>
                                <a href="/whitepaper">Whitepaper & E-books</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <a
                className="header-btn"
                href="/contact-us"
            >
                Contact Us
            </a>
        </div>
    );
};

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [isDropdownVisible, setIsDropdownVisible] = useState(null);

    const toggleLine = () => {
        setIsOpen(!isOpen);
        document.body.style.overflow = isOpen ? 'auto' : 'hidden';
    };

    const toggleDropdown = (dropdownId) => {
        setIsDropdownVisible((prevDropdownId) =>
            prevDropdownId === dropdownId ? null : dropdownId
        );
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setIsOpen(false);
                document.body.style.overflow = 'auto';
            }
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <DesktopNav />
            <div className="header-top desktop-nav">
                <div className="navigation-header">
                    <div className="header">
                        <div className="navigation">
                            <div className="header-content">
                                <a href="/">
                                    <img
                                        src={logo}
                                        alt="Wendu - Cloud Security and Cost"
                                    />
                                </a>

                                <div
                                    className="menu-lines"
                                    onClick={toggleLine}
                                >
                                    <div
                                        className={
                                            isOpen
                                                ? 'navbar-toggle open'
                                                : 'navbar-toggle'
                                        }
                                    >
                                        <div className="lines">
                                            <span />
                                            <span />
                                            <span />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={
                            isOpen
                                ? 'mobile-nav-container show-mobile'
                                : 'mobile-nav-container'
                        }
                    >
                        <div className="mobile-nav">
                            <ul>
                                <li className="dropdown-container">
                                    <a
                                        className={`nav-link ${
                                            isDropdownVisible === 1
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() => toggleDropdown(1)}
                                        href="#products"
                                    >
                                        <span>Solutions & Offerings</span>{' '}
                                        {isDropdownVisible === 1 ? (
                                            <IoIosArrowUp />
                                        ) : (
                                            <IoIosArrowDown />
                                        )}
                                    </a>
                                    <div className="dropdown">
                                        <div
                                            className={`dropdown-content ${
                                                isDropdownVisible === 1
                                                    ? 'show'
                                                    : ''
                                            }`}
                                        >
                                            <a href="https://wendu.io/">
                                                Wendu
                                            </a>
                                            <a href="/data-analytics">
                                                AI Scan
                                            </a>
                                            <a href="/aws-managed-cloud">
                                                AWS Managed Service
                                            </a>
                                            <a href="/backup-and-restore">
                                                Backup and Restore
                                            </a>
                                            <a href="/cloud-migration">
                                                Cloud Migration
                                            </a>
                                            <a href="/aws-maturity-service">
                                                AWS Maturity Service
                                            </a>
                                            <a href="/security-compliance">
                                                Security Compliance
                                            </a>
                                            <a href="/microsoft-on-aws">
                                                Microsoft on AWS
                                            </a>
                                            <a href="/cloud-resource-managament">
                                                Cloud Resource Management
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li className="dropdown-container">
                                    <a
                                        className={`nav-link ${
                                            isDropdownVisible === 2
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() => toggleDropdown(2)}
                                        href="#professionalservices"
                                    >
                                        <span>Professional Services</span>{' '}
                                        {isDropdownVisible === 2 ? (
                                            <IoIosArrowUp />
                                        ) : (
                                            <IoIosArrowDown />
                                        )}
                                    </a>
                                    <div className="dropdown">
                                        <div
                                            className={`dropdown-content ${
                                                isDropdownVisible === 2
                                                    ? 'show'
                                                    : ''
                                            }`}
                                        >
                                            <a href="/technologies">
                                                Omni-channel Contact Center
                                            </a>
                                            <a href="/devops-as-a-service">
                                                DevOps as a service
                                            </a>
                                            <a href="/training">
                                                Cloud Training
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <a
                                        className="nav-link"
                                        href="/aws-partnership"
                                    >
                                        AWS Partnership
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="nav-link"
                                        href="/case-studies"
                                    >
                                        Case Studies
                                    </a>
                                </li>
                                <li className="dropdown-container">
                                    <a
                                        className={`nav-link ${
                                            isDropdownVisible === 3
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() => toggleDropdown(3)}
                                        href="#resources"
                                    >
                                        <span>Resources</span>{' '}
                                        {isDropdownVisible === 3 ? (
                                            <IoIosArrowUp />
                                        ) : (
                                            <IoIosArrowDown />
                                        )}
                                    </a>
                                    <div className="dropdown">
                                        <div
                                            className={`dropdown-content ${
                                                isDropdownVisible === 3
                                                    ? 'show'
                                                    : ''
                                            }`}
                                        >
                                            <a href="/blog">Blogs</a>
                                            <a href="/events">Events</a>
                                            <a href="/press-release">
                                                Press Releases
                                            </a>
                                            <a href="/whitepaper">
                                                Whitepaper & E-books
                                            </a>
                                            <a href="/knowledge">
                                                Documentation CCMP
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <a
                                        className="btn btn-primary"
                                        href="/contact-us"
                                    >
                                        Contact Us
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
